// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';
// import styles bundle
import 'swiper/css/bundle';
let i = 0;

// Assign individual classes to pagination and bullets for each instance of slider
//Pagination Bullets
const paginationBullets = document.querySelectorAll('.swiper-pagination');
for (i = 0; i < paginationBullets.length; i++) {
    paginationBullets[i].classList.add('swiper-pagination-' + i);
}
//Pagination Arrow Next
const paginationNext = document.querySelectorAll('.swiper-button-next');
for (i = 0; i < paginationNext.length; i++) {
    paginationNext[i].classList.add('swiper-button-next-' + i);
}
//Pagination Arrow Prev
const paginationPrev = document.querySelectorAll('.swiper-button-prev');
for (i = 0; i < paginationPrev.length; i++) {
    paginationPrev[i].classList.add('swiper-button-prev-' + i);
}
//Swiper JS
const swiperSlider = document.querySelectorAll('.swiper-container');
for( i=0; i< swiperSlider.length; i++ ) {
    swiperSlider[i].classList.add('swiper-container-' + i);
    var slider = new Swiper('.swiper-container-' + i, {
        a11y: {
            enabled: true
        },
        centeredSlides: true,
        breakpointBase: 'window',
        slidesPerView: 1,
        spaceBetween: 20,
        slideClass:'swiper-slide',
        navigation: {
            nextEl: '.swiper-button-next-' + i + '',
            prevEl: '.swiper-button-prev-' + i + '',
        },

        pagination: {
            el: '.swiper-pagination-' + i + '',
            clickable: true,
        },
    });
}

// Assign individual classes to pagination and bullets for each instance of slider
//Pagination Bullets
const paginationBulletsAutoplay = document.querySelectorAll('.swiper-pagination-autoplay');
for (i = 0; i < paginationBulletsAutoplay.length; i++) {
    paginationBulletsAutoplay[i].classList.add('swiper-pagination-autoplay-' + i);
}
//Pagination Arrow Next
const paginationNextAutoplay = document.querySelectorAll('.swiper-button-next-autoplay');
for (i = 0; i < paginationNextAutoplay.length; i++) {
    paginationNextAutoplay[i].classList.add('swiper-button-next-autoplay-' + i);
}
//Pagination Arrow Prev
const paginationPrevAutoplay = document.querySelectorAll('.swiper-button-prev-autoplay');
for (i = 0; i < paginationPrevAutoplay.length; i++) {
    paginationPrevAutoplay[i].classList.add('swiper-button-prev-autoplay-' + i);
}

//Swiper JS
const swiperSliderAutoplay = document.querySelectorAll('.swiper-container-autoplay');
for( i=0; i< swiperSliderAutoplay.length; i++ ) {
    swiperSliderAutoplay[i].classList.add('swiper-container-autoplay-' + i);
    var slider = new Swiper('.swiper-container-autoplay-' + i, {
        a11y: {
            enabled: true
        },
        centeredSlides: false,
        breakpointBase: 'window',
        slidesPerView: 1,
        spaceBetween: 20,
        autoplay:{
            delay:3000,
        },
        slideClass:'swiper-slide',
        navigation: {
            nextEl: '.swiper-button-next-autoplay-' + i + '',
            prevEl: '.swiper-button-prev-autoplay-' + i + '',
        },

        pagination: {
            el: '.swiper-pagination-autoplay-' + i + '',
            clickable: true,
        },
    });
}



function setSwiperLinePadding() {
    $('.swiper-line').css('padding-left', '');
    let cardWidth = $('.card-info').outerWidth();
    let navPad = (cardWidth / 2);
    $('.swiper-line').css('padding-left', navPad);
}

let timeoutId;

$(window).on('load resize', function() {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(setSwiperLinePadding, 100);
});